var RosterUploadProgressMeter = require("components/org/roster_upload/RosterUploadProgressMeter");
var RosterUploadButtons = require("components/org/roster_upload/RosterUploadButtons");
var Glyphicon = require("components/utility/icons/Glyphicon");
var StudentRoster = require("lib/data/StudentRoster");

class RosterUploadColumns extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			editMode: this.forceEdits(props)
		};
	}

	toggleEditMode(e) {
		$wr.nope(e)
		this.setState({ editMode: !this.state.editMode }, function() {
			$(window).trigger("resize");
		});
	}

	forceEdits(props) {
		var props = props || this.props;
		return !props.roster.hasAllRequiredColumns();
	}

	splitNameColumn() {
		var mappedRosterData = this.props.roster.splitNameColumn();
		this.props.updateRosterData(mappedRosterData, function() {
			this.setState({ editMode: this.forceEdits() });
		}.bind(this));
	}

	confirmChanges() {
		var mapValues = {};
		var $selects = $(this.refs.colValues).find("[data-col]");

		_.each($selects, function(select) {
			var origCol = $(select).data("col");
			var newVal = $(select).val();
			mapValues[origCol] = newVal;
		});

		var mappedRosterData = this.props.roster.mapColumns(mapValues);
		this.props.updateRosterData(mappedRosterData, function() {
			this.setState({ editMode: this.forceEdits() });
		}.bind(this));
	}

	renderIncompleteStudents() {
		var missingLines = [];
		var incompleteStudents = this.props.roster.studentsMissingColumns();
		_.each(StudentRoster.Columns.REQUIRED_COLUMNS, function(col) {
			var totalMissing = 0;
			var firstMissing = null;

			_.each(incompleteStudents, function(missingData) {
				if (_.includes(missingData.missingColumns, col)) {
					totalMissing += 1;
					if (firstMissing == undefined) {
						firstMissing = missingData;
					}
				}
			});

			if (firstMissing != undefined) {
				if (totalMissing > 1) {
					var missingDetails = "and other " + (totalMissing - 1) +
						$wr.pluralize(" row", totalMissing - 1);
				} else {
					var missingDetails = "is";
				}
				missingLines.push(
					<li>
						<em>{ firstMissing.studentSummary }</em><br />
						<span className="spacer4" />
						{ missingDetails } misssing the column "{ col }."
					</li>
				);
			}
		}.bind(this));

		return missingLines;
	}

	renderExtraColumnAlerts() {
		var roster = this.props.roster;
		var badEmails = roster.invalidParentEmails();
		if (badEmails && badEmails.length > 0) {
			if (badEmails.length == 0) {
				var badEmailText = '1 invalid parent email address, "' + badEmails[0] + '."';
			} else {
				var badEmailText = badEmails.length + ' invalid parent email addresses, like "' + badEmails[0] + '."';
			}

			var badEmailDisplay = (
				<p className="text-smaller alertIndent">
					<Glyphicon icon="exclamation-sign alertMark" /> { badEmailText } The
					associated student { $wr.pluralize("account", badEmails.length) } will
					still be created.
				</p>
			);
		}

		var usernames = roster.validUsernames();
		if (usernames && usernames.length > 0) {
			var usernameDisplay = (
				<p className="text-smaller alertIndent">
					<Glyphicon icon="exclamation-sign alertMark" /> Your roster
					has custom usernames. Since usernames have to be unique across
					all the students on the website, it is possible your usernames will
					have to be modified. For example, if a student with the
					username <strong>{ usernames[0] }</strong> already exists, your student
					may get the username <strong>{ usernames[0] }-1</strong>.
				</p>
			);
		}

		var badPasswords = roster.invalidPasswords();
		if (badPasswords && badPasswords.length > 0) {
			badPasswords = _.sortBy(badPasswords, "length");
			var betterPassword = badPasswords[0];
			while (betterPassword.length < StudentRoster.MIN_PASSWORD_LENGTH) {
				betterPassword += "0";
			}

			var badPasswordDisplay = (
				<p className="text-smaller alertIndent">
					<Glyphicon icon="exclamation-sign alertMark" /> Your roster
					has some custom passwords that are too short. These will be
					increased in length by adding '0's to the end. For example,
					the password <strong>{ badPasswords[0] }</strong> will be 
					extended to <strong>{ betterPassword }</strong>.
				</p>
			);
		}

		return (
			<div>{badEmailDisplay}{usernameDisplay}{badPasswordDisplay}</div>
		);
	}

	renderRosterStatus() {
		var roster = this.props.roster;
		if (roster.hasCombinedNameColumn()) {
			return (
				<div>
					<p className="redBold">
						Uh oh! It looks like you may have combined "First Name" and "Last Name"
						columns into one column. If you want us to try to separate the names
						for you automatically, <a href="#" onClick={ this.splitNameColumn }>click this link</a>.
					</p>

					<p className="redBold">
						Otherwise, manually edit your student roster file and upload it again.
					</p>
				</div>
			)

		} else if (!roster.hasAllRequiredColumns()) {
			var missingCols = _.map(roster.missingColumns(), function(col) {
				return (<li key={ col }>{ col }</li>);
			});
			var unrecognizedCols = _.map(roster.unrecognizedColumns(), function(col) {
				return (<li key={ col }>{ col }</li>);
			});

			if (unrecognizedCols.length > 0) {
				var unrecognizedContent = (
					<div>
						<p className="redBold">
							There were unrecognized { unrecognizedCols.length }
							{ $wr.pluralize("column", unrecognizedCols.length) }.
							Please use the dropdown menus to match the columns with the correct headers.
						</p>

						<ul className="move-in disc">{ unrecognizedCols }</ul>
					</div>
				)
			}

			return (
				<div>
					<p className="redBold">
						Uh oh! Your roster is missing some required columns:
					</p>
					<ul className="move-in disc">
						{ missingCols }
					</ul>

					<p className="redBold">
						If the missing fields just aren't present on your roster, 
						you'll have to edit your CSV and upload it again on the previous page.
					</p>
				</div>
			)

		} else if (!roster.allStudentsHaveRequiredColumns()) {
			return (
				<div>
					<p className="redBold">
						Oh no! Some of your student rows are missing required columns.
						If you proceed, the following students will not get accounts:
					</p>
					<ul className="move-in disc">
						{ this.renderIncompleteStudents() }
					</ul>
					<p className="redBold">
						If you want to make accounts for these students, you will have to edit your
						spreadsheet to add the missing data and upload it again on the previous page.
					</p>
				</div>
			);

		} else {
			return (
				<div>
					<p>
						Your roster has all required columns and your students look good to go!
					</p>
					{ this.renderExtraColumnAlerts() }
				</div>
			);
		}
	}

	renderTableHeader() {
		var roster = this.props.roster;

		if (this.state.editMode) {
			var colOptions = _.map(StudentRoster.Columns.VISIBLE_COLUMNS, function(col) {
				return (<option key={ col } value={ col }>{ col }</option>);
			});
		}

		var cells = _.map(roster.currentColumns(), function(col) {
			var unrecognized = roster.isUnknownColumn(col);
			var optional = roster.isOptionalColumn(col);
			var hidden = roster.isHiddenColumn(col);
			var required = roster.isRequiredColumn(col);
			var tooltipID = "confirmColumn" + col;

			if (unrecognized) {
				var icon = (<Glyphicon icon="question-sign" dataTip="Unknown Column" />);

			} else if (optional || hidden) {
				var icon = (<Glyphicon icon="ok-circle" dataTip="Optional Column" />);

			} else if (required) {
				var icon = (<Glyphicon icon="ok" dataTip="Required Column" />);

			} else { throw "Shouldn't get here" }

			if (this.state.editMode) {
				var defaultValue = roster.isUnknownColumn(col) ? StudentRoster.Columns.IGNORE : col;

				if (roster.isHiddenColumn(col)) {
					colOptions = colOptions.concat([
						<option key={ col } value={ col }>{ col }</option>
					]);
				}

				return (
					<th key={ col }>
						<select defaultValue={ defaultValue } className="form-control" data-col={ col }>
							{ colOptions }
						</select>
					</th>
				);

			} else {
				return (
					<th key={ col } className={ unrecognized ? "unrecognized" : "" } >
						{ icon } { col }
					</th>
				);
			}
		}.bind(this));

		return (<tr ref="colValues">{ cells }</tr>);
	}

	renderTableRows() {
		var roster = this.props.roster;
		const sampleRowCount = 3;

		var rows = [];
		for (var i = 0; i < sampleRowCount; i++) {
			var cells = _.map(roster.currentColumns(), function(col) {
				return (
					<td key={ col } className="csvSampleText">
						{ roster.getValue(col, i) }
					</td>
				);
			});
			rows.push(<tr key={ i }>{ cells }</tr>);
		}

		var extraRowCount = roster.rowCount() - sampleRowCount;
		if (extraRowCount > 0) {
			rows.push(
				<tr key="more">
					<td colSpan={ roster.currentColumns().length } className="text-center">
						<em>... and { extraRowCount } more { $wr.pluralize("row", extraRowCount) }...</em>
					</td>
				</tr>
			);
		}

		return rows;
	}

	render() {
		var roster = this.props.roster;

		return (
			<div className="uploadManager">
				<RosterUploadProgressMeter index={ 1 } />

				{ this.renderRosterStatus() }

				<RosterUploadButtons noun="Columns"
					editMode={ this.state.editMode }
					forceEdits={ this.forceEdits() }
					nextStage={ this.props.nextStage }
					toggleEditMode={ this.toggleEditMode }
					confirmChanges={ this.confirmChanges } />

				<div className="tableWrap">
					<table className="table table-striped table-bordered csvConfirmTable horiz">
						<tbody>
							{ this.renderTableHeader() }
							{ this.renderTableRows() }
						</tbody>
					</table>
				</div>
			</div>
		)
	}
};

RosterUploadColumns.propTypes = StrictPropTypes({
	nextStage: PropTypes.func.isRequired,
	updateRosterData: PropTypes.func.isRequired,

	// Instance of StudentRoster.js
	roster: PropTypes.object.isRequired
});

module.exports = RosterUploadColumns;



// WEBPACK FOOTER //
// ./modules/components/org/roster_upload/RosterUploadColumns.js